import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { FormSecondStep } from "./secondStepForm";
import { StepButton } from "./stepButton";
import { FormFooter } from "./formFooter";
import * as Yup from "yup";
import { wodVoiceSchema } from "./voiceAddSchema";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import { store } from "../../redux/storeConfig/store";
import { updateWod, createWod } from "../../redux/actions/api/apiAction";
import Title from "../title";
import { saveVoiceDraftEdit } from "../voiceAdd/saveDraftEdit";
import { withVoicePrefill } from "../voiceAdd/openForm";

const renderStep = (step, values, errors, touched, setFieldValue) => {
  switch (step) {
    case 1:
      return (
        <FormFirstStep
          errors={errors}
          touched={touched}
          values={values}
          setFieldValue={setFieldValue}
        />
      );
    case 2:
      return (
        <FormSecondStep
          errors={errors}
          touched={touched}
          values={values}
          setFieldValue={setFieldValue}
        />
      );
    default:
      return (
        <FormFirstStep
          errors={errors}
          touched={touched}
          values={values}
          setFieldValue={setFieldValue}
        />
      );
  }
};

function MultiStepForWod({
  name,
  handleSubmit,
  handleSubmitForUpdate,
  instructions,
  type,
  duration,
  edit,
  members,
}) {
  const [step, setStep] = useState(1);
  handleSubmitForUpdate = async (values) => {
    await store.dispatch(updateWod(values));
  };
  handleSubmit = async (values) => {
    if (saveVoiceDraftEdit(values)) return;
    await store.dispatch(createWod(values));
  };
  const submit = (values) => {
    if (step === 2 && edit) {
      handleSubmitForUpdate(values);
    } else {
      if (step === 2) {
        handleSubmit(values);
      } else if (step === 1) {
        setStep((step) => step + 1);
      } else {
        setStep((step) => step);
      }
    }
  };

  const previous = () => setStep((step) => step - 1);

  const formSchema1 = wodVoiceSchema;
  const formSchema2 = Yup.object().shape({
  });

  return (
    <>
      <ModalBody className="wod-first-step">
        <div className="modal-body-content">
          <div className="add-member-popup adding-popup bg-white card-panel">
            <div className="basic-info">
              <div className="info-title with-border">
                <Title
                  title="Add Workout"
                  subtitlestyle="ctf-tx-secondary"
                  subtitle="Add info about Workout"
                />
              </div>
              <Formik
                enableReinitialize
                initialValues={withVoicePrefill("workout", {
                  name,
                  instructions,
                  type,
                  duration,
                  members,
                  edit,
                })}
                onSubmit={submit}
                validationSchema={step === 1 ? formSchema1 : formSchema2}
              >
                {({
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  values,
                  setFieldValue,
                }) => (
                  <Form>
                    {renderStep(step, values, errors, touched, setFieldValue)}
                    <StepButton step={step} previous={previous} edit={edit} />
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </ModalBody>
      <FormFooter step={step}></FormFooter>
    </>
  );
}
MultiStepForWod.defaultProps = {
  name: "",
  type: "",
  duration: null,
  instructions: [],
  members: [],
  handleSubmit: (values) => {
  },
  edit: false,
  handleSubmitForUpdate: (values) => {
  },
};

export default MultiStepForWod;
